import request from 'components/Utils/Request';
const { REACT_APP_API_URL } = process.env;
import axios from 'axios';
export const GET_CUSTOMER_INQUIRY_LIST_REQUEST = 'GET_CUSTOMER_INQUIRY_LIST_REQUEST';
export const GET_CUSTOMER_INQUIRY_LIST_SUCCESS = 'GET_CUSTOMER_INQUIRY_LIST_SUCCESS';
export const GET_CUSTOMER_INQUIRY_LIST_FAILURE = 'GET_CUSTOMER_INQUIRY_LIST_FAILURE';
export const GENERATE_CUSTOMER_INQUIRY_LIST_PDF_REQUEST = 'GENERATE_CUSTOMER_INQUIRY_LIST_PDF_REQUEST';
export const GENERATE_CUSTOMER_INQUIRY_LIST_PDF_SUCCESS = 'GENERATE_CUSTOMER_INQUIRY_LIST_PDF_SUCCESS';
export const GENERATE_CUSTOMER_INQUIRY_LIST_PDF_FAILURE = 'GENERATE_CUSTOMER_INQUIRY_LIST_PDF_FAILURE';

  export const getCustomerInquiryListRequest = () => ({
    type: GET_CUSTOMER_INQUIRY_LIST_REQUEST
  });
  export const getCustomerInquiryListSuccess = payload => ({
    type: GET_CUSTOMER_INQUIRY_LIST_SUCCESS,
    payload
  });
  export const getCustomerInquiryListFailure = payload => ({
    type: GET_CUSTOMER_INQUIRY_LIST_FAILURE,
    payload
  });

    export const generateCustomerInquiryPDFRequest = () => ({
      type: GENERATE_CUSTOMER_INQUIRY_LIST_PDF_REQUEST
    });
    export const generateCustomerInquiryPDFSuccess = payload => ({
      type: GENERATE_CUSTOMER_INQUIRY_LIST_PDF_SUCCESS,
      payload
    });
    export const generateCustomerInquiryPDFFailure = payload => ({
      type: GENERATE_CUSTOMER_INQUIRY_LIST_PDF_FAILURE,
      payload
    });
  

  export const customerDetailAction = payload => {
    return {
      type: 'CUSTOMERINQUIRYDATA',
      payload
    };
  };
  
  export const getCustomerInquiryListAPI = (payload, successData, errorMSg, headers = {}) => {
    return dispatch => {
      dispatch(getCustomerInquiryListRequest());
      return request(
        'POST',
        `${REACT_APP_API_URL + '/customer-inquiry-list'}`,
        payload,
        "",
        headers
      )
        .then(res => {
          if (res?.data.status === 200) {
            successData(res);
            dispatch(getCustomerInquiryListSuccess(res.data.data));
          } else {
            errorMSg(res);
          }
        })
        .catch(err => {
          errorMSg(err?.res);
          dispatch(getCustomerInquiryListFailure('Something went wrong'));
          throw err;
        });
    };
  };

  export const generateCustomerInquiryPdfAPI = (payload, successCallback, errorCallback, headers = {}) => {
    return dispatch => {
      dispatch(generateCustomerInquiryPDFRequest());
      axios
        .post(
          `${REACT_APP_API_URL}/customer-inquiry-list`,
          payload,
          {
            responseType: 'blob',
            headers: headers,
          }
        )
        .then(response => {
          if (response.status === 200 && response.data) {
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const downloadUrl = URL.createObjectURL(blob);
            window.open(downloadUrl, '_blank');
  
            dispatch(generateCustomerInquiryPDFSuccess());
          } else {
            errorCallback("Failed to generate PDF");
            dispatch(generateCustomerInquiryPDFFailure());
          }
        })
        .catch(error => {
          console.error("Error downloading PDF:", error);
          errorCallback("Error occurred while downloading PDF");
          dispatch(generateCustomerInquiryPDFFailure());
        });
    };
  };